import React from "react";
import { useState, useEffect } from "react";
import _ from "lodash";
import { log } from "../Helper";
import { withOktaAuth } from "@okta/okta-react";
import { getInfoDocument } from "./api";
import {
  Box,
  Divider,
  Header,
  HeaderActionArea,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  PopoverButton,
  PopoverContent,
  ThemeProvider,
  Typography,
  Tooltip,
} from "@deere/fuel-react";
import {
  AccountCircleOutlined,
  ExitToAppOutlined,
  InfoOutlined,
} from "@mui/icons-material";
import { Button } from "@mui/material";

const AppHeader = (props) => {
  const [userName, setUserName] = useState(null);
  const fileName = "FOM_HelpFile.pdf";
  const providerId = 123;
  const opId = 123456;
  const docType = "INFO_DOC";
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    setUserName(props.authState.idToken.claims.name);
  }, []);

  function handleClick() {
    log("Logging out");
    props.oktaAuth.signOut();
  }

  const getInfoFile = async () => {
    try {
      setIsClicked(true);
      const response = await getInfoDocument(
        fileName,
        providerId,
        opId,
        docType
      );
      const pdfBlob = new Blob([response], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
      setTimeout(() => {
        setIsClicked(false);
      }, 1000);
    } catch (error) {
      log("Error occured when fetching info file: ", error);
    }
  };

  return (
    <ThemeProvider>
      <Header title="Freight Order Manager">
        <HeaderActionArea>
          <Tooltip placement="bottom" title="Help Document">
            <Button onClick={getInfoFile} disabled={isClicked}>
              <InfoOutlined sx={{ color: "gray" }} />
            </Button>
          </Tooltip>
          <Popover>
            <PopoverButton aria-label={"Account"} component={Button}>
              <AccountCircleOutlined sx={{ color: "gray" }} />
              <Typography
                className="pl-2 uppercase"
                sx={{ color: "gray" }}
                fontWeight={"bold"}
                size={"small"}
              >
                {userName}
              </Typography>
            </PopoverButton>
            <PopoverContent>
              <Box>
                <Box>
                  <Divider />
                  <ListItemButton sx={{ pl: 5 }}>
                    <ListItemIcon>
                      <ExitToAppOutlined />
                    </ListItemIcon>
                    <ListItemText
                      className="pr-9 pt-1"
                      primary={"Sign Out"}
                      onClick={handleClick}
                      primaryTypographyProps={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#333",
                      }}
                    />
                  </ListItemButton>
                </Box>
              </Box>
            </PopoverContent>
          </Popover>
        </HeaderActionArea>
      </Header>
    </ThemeProvider>
  );
};

export default withOktaAuth(AppHeader);
